/**
 * Shared system portal URLs and config for landing sections and app launcher.
 * DS-3: product list synced with packages/design-system/products/ecosystem-products.js
 */

import {
  ECOSYSTEM_PRODUCTS,
  getEcosystemUrls,
  isLocalRuntime,
} from "./ecosystem-products";

export { isLocalRuntime, ECOSYSTEM_PRODUCTS };

export function getSystemUrls() {
  return getEcosystemUrls();
}

/** Card grid config (SystemAccessSection). */
export const SYSTEMS_CONFIG = ECOSYSTEM_PRODUCTS.map((product) => ({
  id: product.id,
  cardKey:
    product.id === "ydim"
      ? "yimnak"
      : product.id === "ingestion"
        ? "systems"
        : product.id === "legal"
          ? "legalIntelligence"
          : product.id,
  urlKey: product.urlKey,
  launcherLabelKey:
    product.id === "ydim"
      ? "appLauncher.ydim"
      : product.id === "arsheef"
        ? "appLauncher.arsheef"
        : product.id === "ingestion"
          ? "appLauncher.ingestion"
          : "appLauncher.legalIntelligence",
}));

/** Quick-access strip links (SystemAccessSection). */
export const QUICK_SYSTEM_LINKS = [
  { type: "hash", to: "#landing-top", labelKey: "quickAccess.home" },
  { type: "hash", to: "#integrated-portal", labelKey: "quickAccess.systems" },
  { type: "ext", urlKey: "arsheef", labelKey: "quickAccess.officeLogin" },
  { type: "ext", urlKey: "ingestion", labelKey: "quickAccess.platform" },
  { type: "in", to: "/contact", labelKey: "quickAccess.contact" },
];
